import { MutationActionCreatorResult } from '@reduxjs/toolkit/query';
import { createContext, useContext } from 'react';

export interface MonitoringTableContextValue {
  // Selection state
  selectedIds: Set<number>;
  selectedCount: number;
  isSelected: (id: number) => boolean;
  toggleSelection: (id: number, checked: boolean) => void;

  // Follow-up action callback
  onUpdateFollowUp?: (props: {
    id: number;
    hasFollowUp: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }) => void | MutationActionCreatorResult<any>;
}

export const MonitoringTableContext = createContext<MonitoringTableContextValue | null>(null);

export const useMonitoringTableContext = () => {
  const context = useContext(MonitoringTableContext);
  if (!context) {
    throw new Error('useMonitoringTableContext must be used within MonitoringTableProvider');
  }
  return context;
};
